export const LOGIN_NOTIFICATION_TRANSLATIONS: Record<string, {
  title: string;
  message: string;
  close: string;
}> = {
  en: {
    title: 'Notification',
    message: 'Official notification will be sent for registration. Please check back for updates.',
    close: 'OK',
  },
  or: {
    title: 'ସୂଚନା',
    message: 'ପଞ୍ଜୀକରଣ ପାଇଁ ଆନୁଷ୍ଠାନିକ ସୂଚନା ପ୍ରେରଣ କରାଯିବ। ଦୟାକରି ଅପଡେଟ୍ ପାଇଁ ପରେ ଯାଞ୍ଚ କରନ୍ତୁ ।',
    close: 'ଠିକ୍ ଅଛି',
  },
};
